import React from "react";
import {
  Box, Grid,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, Paper
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

  render() {
    const groups = this.props.groups;
    const generalJournal = this.props.generalJournal;
    const factories = this.props.factories;
    const selectedDate = this.props.selectedDate;
    const journalData = this.props.journalData;

    let totalCredit = 0;
    let totalDebit = 0;
    journalData.forEach(x => {
      totalCredit += x.credit
      totalDebit += x.debit
    });

    return (
      <Paper elevation={0} style={{ width: '100%', height: '100%', padding: '4px' }}>
        <div
          style={{
            fontFamily: 'sans-serif',
            position: 'relative',
            width: '100%',
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          className="record-container"
        >
          <div className="table-responsive row-top-gap" style={{ width: '100%' }}>
            <div style={{ fontSize: '12px' }}>
              <p style={{ textAlign: 'center', paddingBottom: '3px' }}>{groups[generalJournal.groupID]}</p>
              <p style={{ textAlign: 'center', paddingBottom: '3px' }}>{factories[generalJournal.factoryID]}</p>
              <p style={{ textAlign: 'center', fontSize: '11px' }}>MAIN CASH PAYMENT VOUCHER</p>
            </div>
            &nbsp;
            <Grid container style={{ fontSize: '12px' }}>
              <Grid container xs={8}>
                <Grid item xs={4}>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: '4px' }}
                  >
                    <p>Recipient</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: '4px' }}
                  >
                    <p>Description</p>
                  </div>
                </Grid>
                <Grid item xs={8}>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: '4px' }}
                  >
                    <p>{generalJournal.recipientName ?? '-'}</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: '4px' }}
                  >
                    <p>{journalData.length ? journalData[0].description : ''}</p>
                  </div>
                </Grid>
              </Grid>
              <Grid container xs={4}>
                <Grid xs={6}>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: '4px' }}
                  >
                    <p>V : NO</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: '4px' }}
                  >
                    <p>Date</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: '4px' }}
                  >
                    <p>CHQ No</p>
                  </div>
                </Grid>

                <Grid xs={6}>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: '4px' }}
                  >
                    <p>{generalJournal.referenceNumber}</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: '4px' }}
                  >
                    <p>{selectedDate.split('T')[0]}</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: '4px' }}
                  >
                    <p>{generalJournal.chequeNumber}</p>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Box>
              <TableContainer>
                <Table aria-label="caption table">
                  <TableHead>
                    <TableRow style={{
                      borderBottom: "1px solid black",
                    }}>
                      <TableCell align={'left'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Acc Code</TableCell>
                      <TableCell align={'left'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Account Name</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >QTY</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Rate</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Dr</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Cr</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ borderBottom: '1px solid black' }}>
                    {journalData.map((data, index) => (
                      <TableRow key={index} style={{ borderBottom: '1px solid black' }}>
                        <TableCell align="left" style={{ borderBottom: 'none', fontSize: '11px', padding: '2px' }}>
                          {data.selected[0].ledgerAccountCode}
                        </TableCell>
                        <TableCell align="left" style={{ borderBottom: 'none', fontSize: '11px', padding: '2px' }}>
                          {data.selected[0].ledgerAccountName}
                        </TableCell>
                        <TableCell align="right" style={{ borderBottom: 'none', fontSize: '11px', padding: '2px' }}>
                          {0}
                          </TableCell>
                        <TableCell align="right" style={{ borderBottom: 'none', fontSize: '11px', padding: '2px' }}>
                          {0}
                          </TableCell>
                        <TableCell align="right" style={{ borderBottom: 'none', fontSize: '11px', padding: '2px' }}>
                          {data.debit != 0 ? data.debit.toFixed(2) : ''}
                        </TableCell>
                        <TableCell align="right" style={{ borderBottom: 'none', fontSize: '11px', padding: '2px' }}>
                          {data.credit != 0 ? data.credit.toFixed(2) : ''}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>

                  <TableBody>
                    <TableRow style={{ borderBottom: '1px solid black' }}>
                      <TableCell colSpan={4} style={{ fontSize: '11px', padding: '2px', border: 'none' }} />
                      <TableCell align="right" style={{ fontSize: '11px', padding: '2px', border: 0 }}>
                        {totalDebit.toFixed(2)}
                      </TableCell>
                      <TableCell align="right" style={{ fontSize: '11px', padding: '2px', border: 0 }}>
                        {totalCredit.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            &nbsp;
            &nbsp;
            <br />
            <br />
            <Grid container style={{ fontSize: '12px' }}>
              <Grid item xs={12}>
                <p>{generalJournal.preparedBy == null ? "-" : generalJournal.preparedBy}</p>
              </Grid>
              <Grid item xs={3} align="left">
                <div 
                className="row" 
                align="left"
                >
                  Prepared By
                  </div>
              </Grid>
              <Grid item xs={3} align="left">
                <div 
                className="row" 
                align="left"
                >
                  Checked By
                  </div>
              </Grid>
              <Grid item xs={2} align="left">
                <div 
                className="row" 
                align="left"
                >
                  Approved By
                  </div>
              </Grid>
              <Grid item xs={4} align="left">
                <div 
                className="row" 
                align="right"
                >
                  Received by
                  </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </Paper>
    );
  }
}